<template>
  <div class="panel panel-stretch panel-primary">
    <div class="panel-heading">
      Berichten koppelen
    </div>
    <div class="panel-body">
      <b>Acties</b>
      <ol>
        <li>
          Selecteer <b>per pakket/polis</b> om welke bestaande polis het gaat of dat er een nieuw pakket/polis moet
          worden aangemaakt.
        </li>
        <li>
          Selecteer <b>per ADN bericht</b> hoe dit bericht verwerkt moet worden.
        </li>
        <li>
          (Optioneel) Kies of bijlagen uit de berichten moeten worden opgeslagen
        </li>
      </ol>
    </div>
    <div class="panel-body">
      <b>Stap 1</b>
      <a-collapse>
        <a-collapse-panel :header="'Pakket: ' + getContractNumber(packageMessage, 'Onbekend contractnummer')">

          <span slot="extra">{{ truncate(packageMessageLinkOptions[chosenPackage], 75, '...') }}</span>
          <a-form-item label="Selecteer een pakket">
            <a-select style="width:50%" @change="handlePackageChosen">
              <a-select-option v-for="(option, key) in packageMessageLinkOptions" :key="key" :value="key">
                <p v-html="sanitizedOption(option)"/>
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-collapse-panel>
      </a-collapse>
    </div>

    <div class="panel-body">
      <b>Stap 2</b>
      <a-collapse dis>
        <template v-for="messageGroup in groupedPolicyMessages">

          <a-collapse-panel :disabled="!chosenPackage"
                            :header="'Polis: '+getContractNumber(messageGroup[0], 'Onbekend contractnummer')">

            <span slot="extra">{{
                truncate(linkOptions[linkGroupedMessagesToPolicies[getContractNumber(messageGroup[0])]], 75, '...')
              }}</span>

            <a-form-item label="Selecteer een pakket/polis">
              <a-select v-model="linkGroupedMessagesToPolicies[getContractNumber(messageGroup[0])]"
                        class="message-policy-select" style="width:50%">
                <a-select-option v-if="Object.keys(linkOptions).length === 0" :key="null"
                                 :value="null">
                  {{ "Selecteer eerst een pakketbericht" }}
                </a-select-option>
                <a-select-option v-for="(option, key) in linkOptions" :key="key"
                                 :value="key">
                  <p v-html="sanitizedOption(option)"/>
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-collapse>
              <a-collapse-panel v-for="policyMessage in messageGroup" :key="policyMessage.id"
                                :header="'Bericht ' + policyMessage.message_id">
                <!--              <h5 class="page-header">Berichtnummer: {{ policyMessage.message_id }}</h5>-->

                <span slot="extra">{{ translateProcessMessage(howToProcess[policyMessage.id]) }}</span>

                <a-form-item label="Selecteer wat u met dit bericht wilt doen">
                  <a-radio-group button-style="solid"
                                 :default-value="ProcessAFDMessageTypeEnum.PROCESS"
                                 v-model="howToProcess[policyMessage.id]">
                    <a-radio-button :value="ProcessAFDMessageTypeEnum.PROCESS">
                      Verwerken
                    </a-radio-button>
                    <a-radio-button :value="ProcessAFDMessageTypeEnum.DONT_PROCESS">
                      Niet verwerken
                    </a-radio-button>
                    <a-radio-button :value="ProcessAFDMessageTypeEnum.DECLINE">
                      Afwijzen
                    </a-radio-button>
                  </a-radio-group>
                </a-form-item>
<!--                <div style="padding-top: 10px">-->
<!--                  <input v-model="saveAttachments[policyMessage.id]" :for="packageMessage.id + '-attachment'"-->
<!--                         type="checkbox"-->
<!--                         @change="handleSaveAttachmentsChosen({'policyMessage': policyMessage, 'saveAttachments': saveAttachments[policyMessage.id]})">-->
<!--                  <label :id="packageMessage.id + '-attachment'">Bijlagen uit dit bericht opslaan bij een-->
<!--                    maatschappij</label>-->
<!--                  <link-sivi-message-attachments-overview-component v-if="saveAttachments[policyMessage.id]"-->
<!--                                                                    :afd-message-id="String(policyMessage.id)"-->
<!--                                                                    :policyMessage="policyMessage"></link-sivi-message-attachments-overview-component>-->
<!--                </div>-->
                <sivi-message style="padding-top: 10px" title="Bericht"
                              :afd-message-id="String(policyMessage.id)"></sivi-message>

              </a-collapse-panel>
            </a-collapse>
          </a-collapse-panel>

        </template>
      </a-collapse>

      <a-form-item label="Vervolg pagina">
        <a-select :defaultValue="RedirectPostAFDMessageProcessEnum.MESSAGE_OVERVIEW" style="width:50%"
                  @change="handleRedirectChosen">
          <a-select-option :value="RedirectPostAFDMessageProcessEnum.MESSAGE_OVERVIEW">
            Berichtenoverzicht
          </a-select-option>
          <a-select-option :value="RedirectPostAFDMessageProcessEnum.CUSTOMER_OVERVIEW">
            Klantoverzicht
          </a-select-option>
          <a-select-option :value="RedirectPostAFDMessageProcessEnum.PACKAGE_OVERVIEW">
            Pakketoverzicht
          </a-select-option>
        </a-select>
      </a-form-item>
    </div>

    <div class="panel-footer">

      <button class="btn btn-primary btn-lg" style="margin-top: 10px" type="button" @click="processAllMessages($event)">
        <i
            class="mdi mdi-check-all"></i> Verwerk alle berichten
      </button>
    </div>
    <a-modal :closable="false" :footer="false" :visible="showModal">
      <p>{{ modalMessage }}</p>
      <br/>
      <footer>
        <button class="button button-primary" @click="closeModal('error')">OK</button>
      </footer>
    </a-modal>
    <a-modal :closable="false" :footer="false" :visible="showErrorModal">
      <p>{{ errorMessage }}</p>
      <p v-for="error in errorList" :key="error">- {{ error }}</p>
      <button class="button button-primary" @click="closeErrorModal">OK</button>
    </a-modal>

  </div>
</template>

<script>
import SiviMessageComponent from "./SiviMessageComponent";
import {mapActions, mapGetters} from "vuex";
import store from "../../../store";
import siviModule from "../store";
import {ProcessAFDMessageTypeEnum, RedirectPostAFDMessageProcessEnum} from "~/enums";
import afdMessageApi from "~/api/siviMessage";
import LinkSiviMessageAttachmentsOverviewComponent from "./LinkSiviMessageAttachmentsOverviewComponent";
import DOMPurify from "dompurify";

export default {
  name: "LinkAFDPackageMessagesToPoliciesComponent",
  props: {
    packageMessage: {
      type: Object,
      required: true
    },
    groupedPolicyMessages: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      linkGroupedMessagesToPolicies: {},
      showModal: false,
      showErrorModal: false,
      errorList: [],
      errorMessage: "",
      modalMessage: "",
      responseStatus: null,
      redirect: "",
      processing: false,
      RedirectPostAFDMessageProcessEnum: RedirectPostAFDMessageProcessEnum,
      chosenRedirect: RedirectPostAFDMessageProcessEnum.MESSAGE_OVERVIEW,
      howToProcess: {},
      ProcessAFDMessageTypeEnum: ProcessAFDMessageTypeEnum,
      linkAttachmentsToAgency: {},
      saveAttachments: {}
    };

  }
  ,
  computed: {
    ...mapGetters("sivi", [
      "packageMessageLinkOptions",
      "linkOptions",
      "chosenPackage",
      "newCustomerData",
      "selectedCustomerId",
      "attachmentAgency",
      "linkAttachmentsToAgencyCategory",
    ]),
    packageMessageId() {
      return String(this.packageMessage.id);
    },
  },
  created() {
    if (!store.hasModule("sivi")) {
      store.registerModule("sivi", siviModule);
    }
  },
  mounted() {
  },
  components: {
    SiviMessageComponent,
    LinkSiviMessageAttachmentsOverviewComponent
  },
  methods: {
    ...mapActions("sivi", [
      "setChosenPackage",
      "handleSaveAttachmentsChosen",
    ]),
    translateProcessMessage(type) {
      switch (type) {

        case ProcessAFDMessageTypeEnum.DONT_PROCESS:
          return "Niet verwerken";
        case ProcessAFDMessageTypeEnum.DECLINE:
          return "Afwijzen";
        case ProcessAFDMessageTypeEnum.PROCESS:
        default:
          return "Verwerken";
      }
    },
    getContractNumber(afdMessage, defaultValue = "") {
      return afdMessage.contract_number ? afdMessage.contract_number : defaultValue;
    },
    handlePackageChosen(value) {
      this.clearChosenPolicies();
      this.setChosenPackage(value);
    },
    handleRedirectChosen(value) {
      this.chosenRedirect = value;
    },
    clearChosenPolicies() {
      this.linkGroupedMessagesToPolicies = {};
    },
    processAllMessages() {
      if (this.dataIsValid()) {
        this.responseStatus = null;
        this.redirect = "";
        afdMessageApi.processMessages(
            this.selectedCustomerId,
            this.packageMessage.id,
            this.chosenPackage,
            this.groupedPolicyMessages,
            this.linkGroupedMessagesToPolicies,
            this.newCustomerData,
            this.chosenRedirect,
            this.howToProcess,
            this.linkAttachmentsToAgencyCategory
        )
            .then(response => {
              this.success = response.data.success;
              this.redirect = response.data.redirect;
              if (this.success) {
                window.location.replace(this.redirect);
              } else {
                this.modalMessage = response.data.message;
              }
            });
      }
    },
    dataIsValid() {
      this.errorList = [];
      this.errorMessage = "";

      if (this.selectedCustomerId === false) {
        this.errorMessage = "Selecteer een klant of kies voor een nieuwe klant";
        this.showErrorModal = true;
        return false;
      }

      if (this.chosenPackage === "") {
        this.errorMessage = "Kies een pakket voor het pakketbericht";
        this.showErrorModal = true;
        return false;
      }

      Object.keys(this.groupedPolicyMessages)
          .forEach(function (key) {
            if (typeof key === "undefined") {
              key = "";
            }
            if (!this.linkGroupedMessagesToPolicies[key]) {
              this.errorList.push(this.getContractNumber(this.groupedPolicyMessages[key][0], "Onbekend contractnummer"));
            }
          }.bind(this));

      if (this.errorList.length > 0) {
        this.errorMessage = "Kies een polis voor de volgende contractnummers:";
        this.showErrorModal = true;
        return false;
      }
      return true;
    },
    closeModal() {
      this.showModal = false;
    },
    closeErrorModal() {
      this.showErrorModal = false;
    },
    truncate(text, length, suffix) {
      if (typeof text === 'undefined') {
        return '';
      }
      if (text.length > length) {
        return text.substring(0, length) + suffix;
      } else {
        return text;
      }
    },
    sanitizedOption(option) {
      return DOMPurify.sanitize(option);
    }
  }
};
</script>

<style scoped>
table.table th, table.table td {
  padding: 1.5rem 1rem;
}
</style>
